import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/app/lock.svg'


const _withScopeId = n => (_pushScopeId("data-v-4eb1f48c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screenBlock" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "whole" }
const _hoisted_4 = {
  key: 0,
  class: "lockStyle"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "lock",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { class: "lockText" }
const _hoisted_7 = { class: "restTime" }
const _hoisted_8 = { class: "editRegion" }
const _hoisted_9 = { class: "dsc" }
const _hoisted_10 = { class: "oprate" }
const _hoisted_11 = { class: "blockBtn" }
const _hoisted_12 = { class: "timeStyle" }
const _hoisted_13 = {
  key: 1,
  class: "mark"
}

import { defineComponent, ref, onMounted, computed, watch } from "vue";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import changeCancel from "@/components/homePage/tabItem/changeCancel.vue";
import { getAppBlockList, createScreenkRule } from "@/api/devices";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import AddBlock from "./component/addBlock.vue";
import { calculateDuration } from "@/views/screen/component/fomat";
import { gaEvent } from "@/utils/format";
import { jsonDataBlockRules } from '@/mock/screenBlock.js'



export default /*#__PURE__*/_defineComponent({
  __name: 'screenBlock',
  setup(__props) {

const store = useStore();
const { t } = useI18n();
const id = computed(() => {
  return store.state.currentDeviceId;
});
const isVibe = computed(() => !store.state.isVibe);
let lastUpdateTime = ref(0)
const showUpdateTime = ref(false)

const isLocked = ref(false)
// 禁用开始时间
const blockStart = ref('')
// 禁用结束时间
const blockEnd = ref('')
// 周期
const cycle = ref(0)
// 当前禁用状态
const status = ref('')
const haveScreenRule = ref(false)
// 禁用剩余时间
const restTime = ref('')
// 控制关闭屏幕禁用弹窗的出现
const showCloseBlock = ref(false)
// 展示新增规则侧边
const showSlider = ref(false)

// 当前时间是否处于禁用时间内
const isWithinTimeRange = ref(false)
const countdown = ref({
  hours: 0,
  minutes: 0,
});

// 回显的数据
const isNew = ref(true)
const showData = ref({})

const changeLockStatus = (e: any) => {
  console.log('isLocked', isLocked.value, e);
  if (isVibe.value) {
    isLocked.value = false
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  if (e) {
    isLocked.value = false
    isNew.value = false
    if (haveScreenRule.value) {
      showData.value = {
        'block_start_time': blockStart.value,
        'block_end_time': blockEnd.value,
        'cycle': cycle.value,
        'status': status.value
      }
      console.log('showData.value', showData.value);
    } else {
      // 默认的屏幕禁用规则
      showData.value = {
        'block_start_time': '21:00',
        'block_end_time': '7:00',
        'cycle': 127,
        'status': 'on'
      }
    }
    showSlider.value = true
    gaEvent("ScreenBlock_Pop", {
      event_category: "ScreenBlock",
      event_label: "None",
    });
  } else {
    // 弹出确认解除的弹窗
    showCloseBlock.value = true
    isLocked.value = true
  }
}

const updateInfo = async () => {
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  await getScreenInfo(true)
  if (closeMinutes) {
    clearInterval(closeMinutes);
    setNewMinutesInterval()
  }
}

watch(isWithinTimeRange, (newV) => {
  console.log('isWithinTimeRange', isWithinTimeRange);
  if (newV) {
    startCountown()
  } else {
    clearInterval(closeMinutes)
  }
}, {
  immediate: true
})

// 倒计时的一分钟变化的函数封装
let closeMinutes: any
const startCountown = () => {
  closeMinutes = setInterval(() => {
    checkTimeRange(blockStart.value, blockEnd.value)
    console.log('counter', countdown.value);
  }, 1000 * 60);
}

const setNewMinutesInterval = () => {
  closeMinutes = setInterval(() => {
    checkTimeRange(blockStart.value, blockEnd.value)
  }, 1000 * 60);
}



// 弹窗取消事件 
const confirmRemove = async () => {
  // console.log('aaaa');
  const params = {
    status: 'off'
  }
  await setScreenBlock(params)
  if (closeMinutes) {
    clearInterval(closeMinutes);
  }
  gaEvent("ScreenBlock_ButtonOff", {
    event_category: "ScreenBlock",
    event_label: "None",
  });
  showCloseBlock.value = false
}
// 弹窗确定事件
const closeBlockDialog = () => {
  // console.log('aaaacancel');
  showCloseBlock.value = false
}


// 新增或者修改禁用规则
const editBlock = () => {
  // 已经禁用规则走修改
  console.log('isLocked.value', isLocked.value, haveScreenRule.value);
  if (!isLocked.value) return
  if (haveScreenRule.value) {
    isNew.value = false
    showData.value = {
      'block_start_time': blockStart.value,
      'block_end_time': blockEnd.value,
      'cycle': cycle.value,
      'status': status.value
    }
    console.log('showData.value', showData.value);
  } else {
    showData.value = {}
  }
  showSlider.value = true
  gaEvent("ScreenBlock_Pop", {
    event_category: "ScreenBlock",
    event_label: "None",
  });
}

const closeAdd = async (obj: any) => {
  showSlider.value = false
  console.log('oooo', obj);
  gaEvent("ScreenBlock_ButtonOn", {
    event_category: "ScreenBlock",
    event_label: "None",
  });
  try {
    await setScreenBlock(obj)
  } catch (er) {

  }
}

const close = () => {
  showSlider.value = false
}

onMounted(async () => {
  await getScreenInfo()
  gaEvent("ScreenBlock_PV", {
    event_category: "ScreenBlock",
    event_label: "None",
  });
  if (haveScreenRule.value) {
    checkTimeRange(blockStart.value, blockEnd.value)
    console.log('countdown', countdown.value);
  }
})

watch(id, async () => {
  await getScreenInfo()
  console.log('haveScreenRule', haveScreenRule.value, isWithinTimeRange.value);
  gaEvent("ScreenBlock_PV", {
    event_category: "ScreenBlock",
    event_label: "None",
  });
  if (haveScreenRule.value) {
    checkTimeRange(blockStart.value, blockEnd.value)
    console.log('countdown', countdown.value);
  }
})

const getScreenInfo = async (isFromSync: Boolean = false) => {
  if (isVibe.value) {
    haveScreenRule.value = false
    // isNew.value = true
    isLocked.value = false
    isWithinTimeRange.value = false
    lastUpdateTime.value = jsonDataBlockRules.data.update_time
    showUpdateTime.value = true
    return
  }
  try {
    const res = await getAppBlockList(id.value)
    if (res.data.code == 200 && res.data.message == 'OK') {
      console.log('getAppBlockList', res, res.data.data.screen_block_rule);
      if (res.data.data.screen_block_rule) {
        haveScreenRule.value = true
        // isNew.value = false
        isLocked.value = res.data.data.screen_block_rule.status == 'on' ? true : false
        blockStart.value = res.data.data.screen_block_rule.block_start_time
        blockEnd.value = res.data.data.screen_block_rule.block_end_time
        cycle.value = res.data.data.screen_block_rule.cycle
        status.value = res.data.data.screen_block_rule.status
        checkTimeRange(blockStart.value, blockEnd.value)

        console.log('isLocked.value', isLocked.value);

      } else {
        haveScreenRule.value = false
        // isNew.value = true
        isLocked.value = false
        isWithinTimeRange.value = false
      }
      if (!isFromSync) {
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      } else {
        if (lastUpdateTime.value == res.data.data.update_time) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      }

    }

  } catch (err) {
    // globalLoading.value = false
  } finally {
    setTimeout(() => {
      store.commit("setSyncLoading", false);
    }, 1000)
  }
}

const setScreenBlock = async (params: any) => {
  try {
    const res = await createScreenkRule(id.value, params)
    console.log('ressss', res);
    if (res.data.code == 200 && res.data.message == 'OK') {
      if (params.status == 'on') {
        isLocked.value = true
      } else {
        console.log('offfff');
        isLocked.value = false
      }
    }
    getScreenInfo()
  } catch (err) {
  }
}

// 将xx:xx格式的时间转化为时间戳
const checkTimeRange = (startTime: any, endTime: any) => {
  console.log('cyclecycle:', cycle.value, transformToBinary(cycle.value));
  let blockCycle = transformToBinary(cycle.value)
  // 创建一个代表今天日期的对象
  const today = new Date();
  // 获取今天是星期几（0 表示星期日，1 表示星期一，以此类推）
  const dayOfWeek = transformWeek(today.getDay());
  console.log('dayOfWeek', dayOfWeek, transformWeek(dayOfWeek),);
  let result = "";
  // 逐位比较并执行按位与操作
  for (let i = 0; i < 7; i++) {
    if (blockCycle[i] === '1' && dayOfWeek[i] === '1') {
      result += '1';
    } else {
      result += '0';
    }
  }
  let isTodayBlock = false
  if (dayOfWeek == result) {
    isTodayBlock = true
  } else {
    isTodayBlock = false
  }
  console.log('dayOfWeekdayOfWeek', dayOfWeek, result, dayOfWeek == result);



  const now = new Date();
  console.log('startTimestartTime', startTime, endTime);

  const [startHours, startMinutes] = startTime.split(':');
  const [endHours, endMinutes] = endTime.split(':');


  const startTimeMs = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(startHours), parseInt(startMinutes)).getTime();
  const endTimeMs = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(endHours), parseInt(endMinutes)).getTime();
  const currentTimeMs = now.getTime();
  console.log('startTimeMs', startTimeMs, endTimeMs, currentTimeMs);

  const currentDate = new Date(); // 获取当前日期和时间
  const hours = currentDate.getHours().toString().padStart(2, '0'); // 获取小时并补零
  const minutes = currentDate.getMinutes().toString().padStart(2, '0'); // 获取分钟并补零

  const currentTimeString = `${hours}:${minutes}`;


  if (startTime <= endTime) {
    console.log('currentTimeString', currentTimeString, endTime);
    if (currentTimeString >= startTime && currentTimeString < endTime && status.value == 'on') {
      if (status.value == 'on') {
        isLocked.value = true
        if (isTodayBlock) {
          isWithinTimeRange.value = true;
        } else {
          isWithinTimeRange.value = false;
        }

      } else {
        isLocked.value = false
      }
      const timeDifference = endTimeMs - currentTimeMs;
      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

      countdown.value = {
        hours: hours,
        minutes: minutes + 1,
      };
      restTime.value = `${countdown.value.hours}h${countdown.value.minutes}m`
      console.log('restTime.value', restTime.value);
    } else {
      isWithinTimeRange.value = false;
      clearInterval(closeMinutes);
    }
  } else {
    if (currentTimeString >= startTime && currentTimeString <= "23:59" || currentTimeString >= '00' && currentTimeString <= endTime) {
      if (status.value == 'on') {
        isLocked.value = true
        if (isTodayBlock) {
          isWithinTimeRange.value = true;
        } else {
          isWithinTimeRange.value = false;
        }
      } else {
        isLocked.value = false
      }
      let timeAll = []
      // 如果当前时间处于前半夜
      if (currentTimeString >= startTime && currentTimeString <= "23:59") {
        const frontNight = calculateDuration(currentTimeString, "23:59")
        const afterNight = calculateDuration("00:00", endTime)
        timeAll = frontNight.map((item, index) => item + afterNight[index]);
      }

      if (currentTimeString >= '00' && currentTimeString <= endTime) {
        timeAll = calculateDuration(currentTimeString, endTime)
      }

      countdown.value = {
        hours: timeAll[0],
        minutes: timeAll[1] + 1,
      };
      restTime.value = `${countdown.value.hours}h${countdown.value.minutes}m`
      console.log('restTime.value', restTime.value);
    } else {
      isWithinTimeRange.value = false;
      clearInterval(closeMinutes);
    }
  }
};

// 十进制转成七位二进制
const transformToBinary = (tenNum: any) => {
  // 将十进制数转换为二进制字符串
  let binaryString = tenNum.toString(2);

  // 如果二进制位数不足7位，则在前面添加零，直到达到7位
  while (binaryString.length < 7) {
    binaryString = '0' + binaryString;
  }

  return binaryString
}

// 将星期几转化为七位二进制
const transformWeek = (position: any) => {
  let binaryNumber = '0000000'
  binaryNumber = binaryNumber.substr(0, position) + '1' + binaryNumber.substr(position + 1);
  // console.log('binaryNumber',binaryNumber);
  return binaryNumber
}


return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Screen disable'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateHeaderDate: _ctx.updateHeaderDate,
      onUpdateInfo: updateInfo,
      showRightBox: false
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate", "onUpdateHeaderDate"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(isWithinTimeRange.value && isLocked.value ? 'lockPhone' : 'phone')
        }, [
          (isWithinTimeRange.value && isLocked.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("famikeep200.Remaining screen disable time on the target device")), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(restTime.value), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("famikeep200.Disable all screen activities")), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["editBtn", isLocked.value ? 'undisable' : 'disable']),
              onClick: editBlock
            }, null, 2),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_switch, {
                modelValue: isLocked.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLocked).value = $event)),
                size: "large",
                style: {"--el-switch-on-color":"#67C23A","--el-switch-off-color":"#c9cdd4"},
                onChange: changeLockStatus
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    (showCloseBlock.value)
      ? (_openBlock(), _createBlock(changeCancel, {
          key: 0,
          visible: showCloseBlock.value,
          title: _ctx.$t(`famikeep200.Are you sure you want to lift the screen disablement now?`),
          width: 480,
          info: `${_ctx.$t('famikeep200.Remaining screen disable time on the target device')}`,
          onConfirm: closeBlockDialog,
          onCancle: confirmRemove,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('famikeep200.Back')
        }, {
          time: _withCtx(() => [
            _createElementVNode("span", _hoisted_12, _toDisplayString(restTime.value), 1)
          ]),
          _: 1
        }, 8, ["visible", "title", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (showSlider.value)
          ? (_openBlock(), _createBlock(AddBlock, {
              key: 0,
              class: "showAddRule",
              onCloseAdd: closeAdd,
              onClose: close,
              showData: showData.value,
              isNew: isNew.value
            }, null, 8, ["showData", "isNew"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (showSlider.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
      : _createCommentVNode("", true)
  ]))
}
}

})